import { Component, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertService } from 'src/app/services/common/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AbstractControl } from '@angular/forms';
import { catchError, forkJoin, of } from 'rxjs';
import { MatSelectChange } from '@angular/material/select';
import { finalize } from 'rxjs/operators';

type SocialKey =
  | 'website' | 'instagram' | 'facebook' | 'twitter'
  | 'tiktok'  | 'youtube'   | 'linkedin' | 'pinterest' | 'upi_id' | 'buyonline' 
  | 'amazon' | 'flipkart';
  const CANONICAL: Record<SocialKey, string> = {
  website: 'website',
  instagram: 'instagram',
  facebook: 'facebook',
  twitter: 'twitter',
  tiktok: 'tiktok',
  youtube: 'youtube',    
  linkedin: 'linkedin',  
  pinterest: 'pinterest',
  upi_id: 'upi_id',
  buyonline:'buyonline',
  amazon:'amazon',
  flipkart:'flipkart'
};

const LEGACY: Partial<Record<SocialKey, string>> = {
  instagram: 'instagram',
  youtube: 'youtube',
  linkedin: 'linkedin',
};


const URL_FIELDS: SocialKey[] = [
  'website','instagram','facebook','twitter','tiktok','youtube','linkedin','pinterest','upi_id'
  ,'buyonline','amazon','flipkart'
];

const READ_KEYS: Record<SocialKey, (dto: any) => string | undefined> = {
  website:   d => d.website,
  instagram: d => d.instagram ?? d.instagram,
  facebook:  d => d.facebook,
  twitter:   d => d.twitter,
  tiktok:    d => d.tiktok,
  youtube:   d => d.youtube ?? d.youtube,      
  linkedin:  d => d.linkedin ?? d.linkedin,   
  pinterest: d => d.pinterest,
  upi_id:    d => d.upi_id,
  buyonline: d => d.buyonline,
  amazon: d => d.amazon,
  flipkart: d => d.flipkart
};

const WRITE_KEYS: Record<SocialKey, string> = {
  website:   'website',
  instagram: 'instagram',  
  facebook:  'facebook',
  twitter:   'twitter',
  tiktok:    'tiktok',
  youtube:   'youtube',  
  linkedin:  'linkedin',  
  pinterest: 'pinterest',
  upi_id:    'upi_id',
  buyonline:'buyonline',
  amazon:'amazon',
  flipkart:'flipkart'
};

export type ObjectId = string;

export interface OrganizationDTO {
  instagram: string;
  linkedin: string;
  youtube: string;
  upi_id: string;
  address: string;
  cityId: ObjectId;
  company: string;
  countryId: ObjectId;
  cover_photo: string;
  created: string;          // ISO date
  createdBy: string;
  email: string;
  facebook: string;
  firstName: string;
  id: ObjectId;
  industryVertical: string;
  isActive: boolean;
  lastName: string;
  modified: string;        
  modifiedBy: string;
  partnerId: string;
  pinterest: string;
  planExpiryDate: string;   
  registrationDate: string; 
  stateId: ObjectId;
  status: string;
  subscriptionPlan: string;
  telephone: string;
  termsCondition: boolean;
  tiktok: string;
  twitter: string;
  buyonline:string;
  amazon:string;
  flipkart:string;
  typeOfAgency: string;
  userType: string[];      
  verified: boolean;
  waNumber: string;
  web_url: string;
  website: string;
}


@Component({
  selector: 'app-media-links',
  templateUrl: './media-links.component.html',
  styleUrls: ['./media-links.component.scss'],
})
export class MediaLinksComponent {

  private suppressGlobalToast = false;
  private initialValue!: any;
  private isWaCancelled = false;
  saving = false;   
  form: FormGroup;
  loading: Record<string, boolean> = {};
   @Input() org?: OrganizationDTO;
  loadingGlobal = false;
  displayedColumns = ['icon', 'url', 'actions'];

socialRows = [
  { fa: 'fa-solid fa-globe',             label: 'Website',   controlName: 'website',   placeholder: 'Website URL' },

  { img: 'assets/icons/instagram.png',        label: 'Instagram', controlName: 'instagram', placeholder: 'Instagram'  },
  { fa: 'fa-brands fa-facebook-f',       label: 'Facebook',  controlName: 'facebook',  placeholder: 'Facebook'   },
  { img: 'assets/icons/twitter.png',          label: 'X / Twitter', controlName: 'twitter', placeholder: 'X / Twitter' },

  { img: 'assets/icons/tiktok.png',      label: 'TikTok',    controlName: 'tiktok',    placeholder: 'TikTok'     },

  { fa: 'fa-brands fa-youtube',          label: 'YouTube',   controlName: 'youtube',   placeholder: 'YouTube'    },
  { img: 'assets/icons/linkedin-logo.png',      label: 'LinkedIn',  controlName: 'linkedin',  placeholder: 'LinkedIn'   },
  { img: 'assets/icons/pinterest.png',      label: 'Pinterest', controlName: 'pinterest', placeholder: 'Pinterest'  },

  { img: 'assets/icons/upiLogo.png',         label: 'UPI Id',    controlName: 'upi_id',    placeholder: 'UPI Id'     },
  { img: 'assets/icons/shopifyIcon.png',      label: 'Buy Online',    controlName: 'buyonline',    placeholder: 'Buy Online'     },
  { img: 'assets/icons/Amazon.jpg',      label: 'Amazon',    controlName: 'amazon',    placeholder: 'Amazon'     },
  { img: 'assets/icons/Flipkart.jpg',      label: 'Flipkart',    controlName: 'flipkart',    placeholder: 'Flipkart'     }
];
  messages = [
  "Hi, thank you for your interest. How may I help you today?",
  "Hello! We're glad you're here. What can we assist you with?",
  "Hi there! Need any help getting started?",
  "Thanks for reaching out! How can we support you today?",
  "Hello! Let us know how we can make your experience better.",
  "Hi! We're here to help. Please tell us what you need.",
  "Welcome! Do you have any questions or need assistance?",
  "Thanks for connecting with us! How can we assist you further?",
  "Hi, we're happy to assist you. What brings you here today?",
  "Hello! Have any questions? We're just a message away."
  ];

  filteredMessages: string[] = [];
  editing: Record<SocialKey, boolean> = {
    website:false, instagram:false, facebook:false, twitter:false,
    tiktok:false, youtube:false, linkedin:false, pinterest:false, upi_id: false,
    buyonline:false ,amazon:false,flipkart:false

  };

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private snackBar: MatSnackBar,
    private alertService: AlertService
  ) {
    this.form = this.fb.group({
      waTitle: [''],
      waEnabled: [true],
      waNumber: [''],
      website:[''],
      instagram: [''],
      facebook: [''],
      twitter: [''],
      tiktok: [''],
      youtube: [''],
      linkedin: [''],
      pinterest: [''],
      upi_id: [''],
      buyonline: [''],
      amazon: [''],
      flipkart: ['']
    });
  }


   async ngOnInit() {
      this.filteredMessages = [...this.messages];
        this.getUserData()
        this.getLinks();
        // this,this.getLinks()
   }


  get f(): { [key: string]: AbstractControl<any, any> } {
  return this.form.controls as { [key: string]: AbstractControl<any, any> };
}

  private toast(msg: string, ok = true) {
    if (this.alertService) {
      if (ok) {
        this.alertService.showSuccess(msg);
      } else {
        this.alertService.showError(msg);
      }
    } else {
      this.snackBar.open(msg, ok ? 'OK' : 'Dismiss', { duration: 2200 });
    }
  }

  onCancel(): void {
    this.form.get('waNumber')?.setValue('');
    this.isWaCancelled = true;
    this.form.get('waNumber')?.markAsDirty();
  }

  private getCurrentUserId(): string | null {
    try {
      const raw = localStorage.getItem('currentUser');
      if (!raw) return null;
      const u = JSON.parse(raw);
      return u?.id ?? u?._id ?? null;
    } catch { return null; }
  }

  getUserData(){
       this.userService.detail(this.getCurrentUserId()).subscribe(async (response: any) => {
      if (response) {
        const allData=response;
        this.org = allData.data;
        //console.log(this.org);
        this.patchFromDto(allData.data)
      }
      else{

      }
    })
    }

    getLinks() {
  this.userService.getLinks(this.getCurrentUserId()).subscribe((response: any) => {
    if (response) {
      this.org = response.data;
      this.patchFromDto2(response.data);

      this.initialValue = this.form.getRawValue(); 
      this.isWaCancelled = false;
      this.form.markAsPristine();
    }
  });
}

hasRealChanges(): boolean {
  if (!this.initialValue) return false;

  const mediaKeys = Object.keys(CANONICAL) as SocialKey[];

  const mediaChanged = mediaKeys.some(k =>
    this.normalize(this.form.get(k)?.value) !==
    this.normalize(this.initialValue?.[k])
  );

  const waVal = this.normalize(this.form.get('waNumber')?.value);
  const waChanged =
    waVal !== this.normalize(this.initialValue?.waNumber) ||
    (this.isWaCancelled && waVal !== '');

  return mediaChanged || waChanged;
}

  patchFromDto(dto: any): void {

  }

patchFromDto2(dto: any): void {
  (Object.keys(CANONICAL) as SocialKey[]).forEach(k => {
    this.form.get(k)?.setValue(this.readValue2(dto, k));
  });
  const wp = dto.find((el: any) => el.mediaType == 'waNumber');
  this.form.get('waNumber')?.setValue((wp?.mediaValue ?? '').toString());
}
  onInputFocus() {
    this.filteredMessages = [...this.messages];
  }

  onSelectionChange(event: MatSelectChange) {
 // this.form.get('waMessage')?.setValue(event.value ?? '');
}

  displayFn(value: string): string {

    return value || '';
  }


onEdit(field: SocialKey) {
  this.editing[field] = true;
}

onSave(r: { controlName: SocialKey; label: string }) {
  const control = this.form.get(r.controlName);
  const newValue = (control?.value ?? '').trim();
  const oldValue = (this.initialValue?.[r.controlName] ?? '').trim();

  if (newValue === oldValue) {
    this.editing[r.controlName] = false;
    return;
  }

  const isFirstSave = !oldValue && !!newValue;
  const isUpdate    = !!oldValue && !!newValue;

  const id = this.getCurrentUserId();
  if (!id) return;

  this.loadingGlobal = true;

  this.userService.media1(id, r.controlName, newValue)
    .pipe(finalize(() => this.loadingGlobal = false))
    .subscribe({
      next: () => {
  this.editing[r.controlName] = false;

  this.suppressGlobalToast = true;

  if (isFirstSave) {
    this.toast('Saved successfully');
  } else if (isUpdate) {
    this.toast('Updated successfully');
  }

  this.initialValue[r.controlName] = newValue;
  control?.markAsPristine();
},

error: () => {
  this.editing[r.controlName] = false;
  this.toast('Operation failed', false);
}
    });
}


  private keyForBackend(k: SocialKey): string {
  return WRITE_KEYS[k] || k;
}

onDelete(field: SocialKey) {
  const backendKey = this.keyForBackend(field);
  const userId = this.getCurrentUserId();
  if (!userId) return;

  this.loading[field] = true;

  this.userService.media1(userId, backendKey, '')
    .pipe(finalize(() => this.loading[field] = false))
    .subscribe({
      next: () => {
  this.suppressGlobalToast = true; 

  this.form.get(field)?.setValue('');
  this.editing[field] = false;

  this.initialValue[field] = '';
this.form.markAsPristine(); 
  this.toast('Deleted successfully');
},

      error: () => this.toast(`Failed to delete ${field}`, false)
    });
}

private normalize(val: any): string {
  return (val ?? '').toString().trim();
}

saveAll() {
  if (this.suppressGlobalToast) {
    this.suppressGlobalToast = false;
    return;
  }

  if (!this.hasRealChanges()) {
    this.toast('No changes to update', false);
    return;
  }

  const id = this.getCurrentUserId();
  if (!id) return;

  const current = this.form.getRawValue();

  const mediaKeys = Object.keys(CANONICAL) as SocialKey[];

const hadDataBefore = mediaKeys.some(
  k => !!this.normalize(this.initialValue?.[k])
);

const hasDataNow = mediaKeys.some(
  k => !!this.normalize(current[k])
);

  const isFirstSave = !hadDataBefore && hasDataNow;
  // const isUpdate    = hadDataBefore && this.hasRealChanges();
const isMediaUpdate =
  hadDataBefore &&
  mediaKeys.some(k =>
    this.normalize(current[k]) !==
    this.normalize(this.initialValue?.[k])
  );
  // this.saving = true;
  const calls = Object.entries(current)
.filter(([k]) => mediaKeys.includes(k as SocialKey))
    .filter(([k, v]) =>
      this.normalize(v) !== this.normalize(this.initialValue?.[k])
    )
    .map(([k, v]) => this.userService.media1(id, k, this.normalize(v)));

  const waVal = this.normalize(this.form.get('waNumber')?.value);
  const waChanged =
    waVal !== this.normalize(this.initialValue?.waNumber) ||
    (this.isWaCancelled && waVal !== '');

const waCall = waChanged
  ? this.userService.media1(
      id,
      'waNumber',
      waVal
    )
  : null;

  const allCalls = [
    ...calls,
    ...(waCall ? [waCall] : [])
  ];

  if (!allCalls.length) {
    this.toast('No changes to update', false);
    return;
  }

  this.saving = true;

  const waOld = this.normalize(this.initialValue?.waNumber);
const waNew = this.normalize(this.form.get('waNumber')?.value);

const isWaFirstSave = !waOld && !!waNew;
const isWaUpdate    = !!waOld && waOld !== waNew;

  forkJoin(allCalls)
    .pipe(finalize(() => (this.saving = false)))
    .subscribe({
next: () => {
  this.isWaCancelled = false;

  if (isFirstSave || isWaFirstSave) {
    this.toast('Saved successfully');
  } else if (isMediaUpdate || isWaUpdate || waChanged) {
    this.toast('Updated successfully');
  } else {
    this.toast('Updated successfully');
  }

  this.initialValue = this.form.getRawValue();
  this.form.markAsPristine();
},
      error: () => this.toast('Update failed', false)
    });
}


private readValue(dto: any, key: SocialKey): string {
  const canonical = CANONICAL[key];
  const legacy = LEGACY[key];

  const v1 = (dto?.[canonical] ?? '').toString().trim();
  if (v1) return v1;

  const v2 = legacy ? (dto?.[legacy] ?? '').toString().trim() : '';
  return v2 || '';
}

private readValue2(dto: any, key: SocialKey): string {
  const canonical = CANONICAL[key];
  const legacy = LEGACY[key];

  const datav1 = dto?.find((e:any)=>e.mediaType === canonical);
  const v1 = (datav1?.mediaValue ?? '').toString().trim();
  if (v1) return v1;

  const datav2 = legacy ? dto?.find((e:any)=>e.mediaType === legacy) : null;
  const v2 = (datav2?.mediaValue ?? '').toString().trim();
  if (v2) return v2;

  return '';
}


}